import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const GDRFALogin: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('Please enter both username and password');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        'https://smart.gdrfad.gov.ae/api/login',
        { username: username.trim(), password: password.trim() },
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        }
      );

      if (response.status === 200 && response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        navigate('/dashboard');
      } else {
        throw new Error('Authentication failed');
      }
    } catch (err: any) {
      const status = err.response?.status;
      if (status === 401) setError('Invalid username or password');
      else if (status === 403) setError('Account locked or inactive');
      else if (status === 429) setError('Too many attempts. Try again later.');
      else setError('Login failed. Please try again later.');

      console.error('Login error:', err);
    } finally {
      setLoading(false);
      setPassword('');
    }
  };

  return (
    <div className="login-container">
      <h2>GDRFA Smart Services Login</h2>
      {error && <div className="error">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Username</label>
          <input
            type="text"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Password</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
};

export default GDRFALogin;